import api from '@/api/master_document'
import { errorHandler } from "../exports/error_management"
import axios from 'axios'
const state = {
    document_type: null,
    drivers: [],
    items: [],
    items_not_paginated: [],
    pagination: null,
    document_types : [],
    attachments: [],
    // master_document : null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    set_items_not_paginated(state, payload) {
        state.items_not_paginated = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_vehicle(state, document_type) {
        state.document_type = document_type
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
    SET_DOCUMENT_TYPES(state,types){
        state.document_types = types
    },
    SET_ATTACHMENTS(state, attachments) {
        state.attachments = attachments;
      },
      clearAssetsAttachments(state) {
        state.attachments = [];
    },
    set_document(state, document_type) {
        state.document_type = document_type
    },
   
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: document_type },
                    },
                }) => {
                    console.log('store vehecddddd', document_type)
                    context.commit('set_document', document_type)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchDrivers(context) {
        //const driver_role_id = 2
        return api
            .fetchDrivers()
            .then(
                ({
                    data: {
                        success: {
                            data: { data: drivers },
                        },
                    },
                }) => {
                    /*  console.log('drivers', drivers)
                    drivers = drivers.filter(
                        x => !!x.roles.find(r => r.role_id == driver_role_id)
                    ) */
                    context.commit('set_drivers', drivers)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    async fetchDocumentTypes(context){
        try {
            const response = await api.fetchDocumentType(); // Adjust the API endpoint accordingly
      
            context.commit("SET_DOCUMENT_TYPES", response.data.success.data);
          } catch (error) {
            console.error("Error fetching orders:", error);
          }
    },
    fetch(context, payload) {
        console.log('payload-', payload)
       
        return api
            .fetch(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    if(payload.page && payload.page > 0){
                        console.log('pag', pag)
                        let users = pag.data

                        context.commit('set', users)
                            //let pag = result.data.success.data
                        context.commit('set_pagination', {
                            page: pag.current_page,
                            pageSize: pag.per_page,
                            total: pag.total,
                        })
                    } else {
                        console.log('pag', pag)
                        let items = pag

                        context.commit('set_items_not_paginated', items)
                    }
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetch_data(context, payload) {
        console.log('payload-', payload)
        payload.page = payload.page || 1
        return api
            .fetch_data(payload.query, payload.page,payload.filters)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    if(payload.page && payload.page > 0){
                        console.log('pag', pag)
                        let users = pag.data

                        context.commit('set', users)
                            //let pag = result.data.success.data
                        context.commit('set_pagination', {
                            page: pag.current_page,
                            pageSize: pag.per_page,
                            total: pag.total,
                        })
                    } else {
                        console.log('pag', pag)
                        let items = pag

                        context.commit('set_items_not_paginated', items)
                    }
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

    async fetchAttachments(context, asset_id) {
        console.log('attachment is called');
        try {
          if(context.rootState.masterdocAttachmentsStore.attachments.length > 0){
            return;
          }
          if (
            state.attachments.length > 0 &&
            state.attachments[0].asset_id == asset_id
          ) {
            return;
          }
          const result = await axios.get(`master-document/${asset_id}/attachments`)
    
          context.commit("SET_ATTACHMENTS", result.data.success.data);
        } catch (err) {
          errorHandler(err);
        }
      },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}